import {
  MetaTagsSkillFormData,
  ProductDescriptionSkillFormData,
  SingleSkillFormData,
} from '../dataModels/SkillFormData'

export const SKILL_FORMAL_REWRITING_EXAMPLES = [
  new SingleSkillFormData('formal_rewriting_input_0'),
  new SingleSkillFormData('formal_rewriting_input_1'),
  new SingleSkillFormData('formal_rewriting_input_2'),
]

export const SKILL_PARAPHRASING_EXAMPLES = [
  new SingleSkillFormData('paraphrasing_input_0'),
  new SingleSkillFormData('paraphrasing_input_1'),
  new SingleSkillFormData('paraphrasing_input_2'),
  new SingleSkillFormData('paraphrasing_input_3'),
  new SingleSkillFormData('paraphrasing_input_4'),
]
export const SKILL_KEYWORDS_EXTRACTION_EXAMPLES = [
  new SingleSkillFormData('keywords_extraction_input_0'),
  new SingleSkillFormData('keywords_extraction_input_1'),
  new SingleSkillFormData('keywords_extraction_input_2'),
  new SingleSkillFormData('keywords_extraction_input_3'),
]

export const SKILL_SUMMARIZATION_EXAMPLES = [
  new SingleSkillFormData('summarization_input_0'),
  new SingleSkillFormData('summarization_input_1'),
  new SingleSkillFormData('summarization_input_2'),
  new SingleSkillFormData('summarization_input_3'),
  new SingleSkillFormData('summarization_input_4'),
]

export const SKILL_STORY_WRITING_EXAMPLES = [
  new SingleSkillFormData('story_writing_input_0'),
  new SingleSkillFormData('story_writing_input_1'),
  new SingleSkillFormData('story_writing_input_2'),
  new SingleSkillFormData('story_writing_input_3'),
]

export const SKILL_BULLET_POINTS_EXTRACTION_EXAMPLES = [
  new SingleSkillFormData('bullet_points_input_0'),
  new SingleSkillFormData('bullet_points_input_1'),
  new SingleSkillFormData('bullet_points_input_2'),
  new SingleSkillFormData('bullet_points_input_3'),
]

export const SKILL_INFORMAL_REWRITING_EXAMPLES = [
  new SingleSkillFormData('informal_rewriting_input_0'),
  new SingleSkillFormData('informal_rewriting_input_1'),
  new SingleSkillFormData('informal_rewriting_input_2'),
  new SingleSkillFormData('informal_rewriting_input_3'),
  new SingleSkillFormData('informal_rewriting_input_4'),
]

export const SKILL_EXTRACT_SEO_OPTIMIZED_EXAMPLES = [
  new SingleSkillFormData('extract_seo_optimized_input_0'),
  new SingleSkillFormData('extract_seo_optimized_input_1'),
]

const PRODUCT_DESCRIPTION_0 = new ProductDescriptionSkillFormData(
  'product_description_name_0',
  'product_description_type_0',
  'product_description_characteristic_0',
  'product_description_audience_0'
)

const PRODUCT_DESCRIPTION_1 = new ProductDescriptionSkillFormData(
  'product_description_name_1',
  'product_description_type_1',
  'product_description_characteristic_1'
)

export const SKILL_PRODUCT_DESCRIPTION_EXAMPLES = [PRODUCT_DESCRIPTION_0, PRODUCT_DESCRIPTION_1]

const META_TAGS_0 = new MetaTagsSkillFormData(
  'meta_tags_name_0',
  'meta_tags_product_or_service_name_0',
  'meta_tags_product_or_service_type_0',
  'meta_tags_product_or_service_characteristic_0'
)

const META_TAGS_1 = new MetaTagsSkillFormData(
  'meta_tags_name_1',
  'meta_tags_product_or_service_name_1',
  'meta_tags_product_or_service_type_1',
  'meta_tags_product_or_service_characteristic_1'
)
const META_TAGS_2 = new MetaTagsSkillFormData(
  'meta_tags_name_2',
  'meta_tags_product_or_service_name_2',
  'meta_tags_product_or_service_type_2',
  'meta_tags_product_or_service_characteristic_2'
)

export const SKILL_META_TAGS_EXAMPLES = [META_TAGS_0, META_TAGS_1, META_TAGS_2]
